import { AggregatesValue, IParamsByUrl } from '~types/search'

const applyFilters = ({
  urlParams,
  filters,
}: {
  urlParams: IParamsByUrl
  filters?: Record<string, AggregatesValue>
}) => {
  const newParams = {
    ...urlParams,
    ...(filters || {}),
  }

  return newParams
}

export default applyFilters
